module.exports = __webpack_public_path__ + "static/media/19ESCAP16.c4966e8a.jpg";